import React, { SVGProps } from 'react'

import MeasurIcon from './MeasurIcon'

export default class IconSocialTwitter extends MeasurIcon<
  SVGProps<SVGSVGElement>
> {
  render() {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        stroke="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        {...this.props}
      >
        <path
          d="M19.1667 2.49999C18.3687 3.06289 17.4851 3.49341 16.55 3.77499C16.0481 3.19791 15.3811 2.7889 14.6392 2.60326C13.8973 2.41762 13.1162 2.46432 12.4017 2.73703C11.6872 3.00975 11.0737 3.49532 10.6442 4.12808C10.2146 4.76085 9.98975 5.51027 10 6.27499V7.10832C8.53553 7.14629 7.0844 6.8215 5.77584 6.16286C4.46729 5.50422 3.34193 4.53218 2.5 3.33332C2.5 3.33332 -0.833333 10.8333 6.66667 14.1667C4.95044 15.3316 2.90596 15.9158 0.833334 15.8333C8.33333 20 17.5 15.8333 17.5 6.24999C17.4992 6.01787 17.4769 5.78632 17.4333 5.55832C18.2838 4.71957 18.884 3.66058 19.1667 2.49999Z"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}
